import { Box, Button, Checkbox, Dialog, DialogActions, DialogContent, DialogTitle, Link, TextField, Typography } from "@mui/material";
import Logo from "../../assets/logo2.png";
import { ROUTES } from "../../router/constants";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import { toast } from "sonner";
import { registerUser } from "../../services/register.service";
import { handleSignin } from "../../services/signin.service";

export function Register(){

        const [formData, setFormData] = useState({
      nome: "",
      email: "",
      senha: "",
      confirmarSenha: "",
      termos: false,
    });

    const navigate = useNavigate();
    

    const [submitedError, setsubmitedError] = useState(false);
    const [openTermsModal, setOpenTermsModal] = useState(false);

    const handleChange = (e:any) => {
      const { name, value } = e.target;
      setFormData((prev) => ({ ...prev, [name]: value }));
    };

    
    const handleCheckboxChange = (e:any) => {
      setFormData((prev) => ({ ...prev, termos: e.target.checked }));
    };

    const handleSubmit = async () => {
      const {nome, senha, email, confirmarSenha, termos} = formData
      console.log("📦 Dados do formulário:", formData);

      if (!termos) {
        toast.error("Você precisa aceitar os termos para continuar.");
        return;
      }

      if (senha !== confirmarSenha) {
        toast.error("As senhas não coincidem!");
        return;
      }

      if(email.length < 1 ){
        setsubmitedError(true)
      }else{
        setsubmitedError(false)
      }
      if(senha.length < 1 ){
        setsubmitedError(true)
      }else{
        setsubmitedError(false)
      }
      if(confirmarSenha.length < 1 ){
        setsubmitedError(true)
      }else{
        setsubmitedError(false)
      }
      if(nome.length < 1 ){
        setsubmitedError(true)
      }else{
        setsubmitedError(false)
      }

      const result = await registerUser(nome, email, senha, confirmarSenha, termos);

      if (!result) {
        // Erro já foi exibido pelo serviço de cadastro
        return;
      }

      // Cadastro criado com sucesso, realiza login automático
      await handleSignin(email, senha);
    };
    

    return(
    <Box padding={4} sx={{
        display:"flex",
        flexDirection:"column",
        alignItems: "center",
        justifyContent:{
            xs: "center",
            sm:"space-between",
        },
        gap:5,
        background: "#fff",
        borderRadius: 2,
        width: "100%",
        maxWidth: 500,
        height:{
          xs: "100dvh",
          sm: "auto",  
        },
    }}>
        <Box display={"flex"} flexDirection={"column"} alignItems={"center"} gap={2} width={"100%"}>
            <img src={Logo} width={180}></img>
            <Typography variant="h6" fontWeight={500} color="#505152ff">Registrar</Typography>
            <Typography variant="subtitle1" color="#8d8f92ff">Já tem uma conta?
                <Button onClick={()=> navigate(`${ROUTES.SIGNIN}`)}>Fazer Login</Button>
            </Typography>
        </Box>

        <Box display={"flex"} flexDirection={"column"} gap={3} width={"100%"}> 
            <TextField label="Nome"  name="nome" fullWidth required type="text" value={formData.nome} 
                error={submitedError && !formData.nome} 
                helperText={submitedError  && !formData.nome ? "O nome é obrigatório" : ""}
                onChange={handleChange}>
            </TextField>

            <TextField label="E-mail" name="email" fullWidth required type="email" value={formData.email} 
              onChange={handleChange}
              error={submitedError && !formData.email} 
              helperText={submitedError  && !formData.email ? "O e-mail é obrigatório" : ""}
            >
            </TextField>

            <TextField label="Senha" name="senha" fullWidth required type="password" value={formData.senha} 
              onChange={handleChange}
              error={submitedError && !formData.senha} 
              helperText={submitedError  && !formData.senha ? "A senha é obrigatória" : ""}
            >
            </TextField>

            <TextField label="Confirmar Senha" name="confirmarSenha" fullWidth required type="password" 
              value={formData.confirmarSenha} 
              onChange={handleChange}
              error={submitedError && !formData.confirmarSenha} 
              helperText={submitedError  && !formData.confirmarSenha ? "A confirmação é obrigatória" : ""}
            >
            </TextField>
            
            <Box display="flex" alignItems="center" flexWrap="wrap" gap={0.5}>
              <Checkbox checked={formData.termos} onChange={handleCheckboxChange} />
              <Typography variant="body2">
                Declaro que li e concordo com os
                <Button
                  variant="text"
                  size="small"
                  sx={{
                    textTransform: "none",
                    fontWeight: 600,
                    ml: 0.5,
                    p: 0,
                    minWidth: "auto",
                  }}
                  onClick={() => setOpenTermsModal(true)}
                >
                  Termos de Uso
                </Button>
              </Typography>
            </Box>
        </Box>

        <Box width={"100%"}>
            <Button variant="contained" fullWidth sx={{height:"50px"}} onClick={handleSubmit}>Registrar</Button>
        </Box>

        <Dialog open={openTermsModal} onClose={() => setOpenTermsModal(false)} fullWidth maxWidth="md">
          <DialogTitle>Termos de Uso – Sagrada Visão</DialogTitle>
          <DialogContent dividers sx={{ maxHeight: "70vh" }}>
            <Typography variant="body2" color="text.secondary" gutterBottom>
              Última atualização: 10/01/2026
            </Typography>

            <Box mt={2}>
              <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                1. Quem somos
              </Typography>
              <Typography variant="body2" paragraph>
                O Sagrada Visão é um aplicativo que ajuda você a se conectar com médicos oftalmologistas parceiros,
                facilitando o agendamento e o acompanhamento de consultas.
              </Typography>

              <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                2. Aceitação dos termos
              </Typography>
              <Typography variant="body2" paragraph>
                Ao se cadastrar, acessar ou usar o Sagrada Visão, você declara que leu e concorda com estes Termos de Uso
                e que tem pelo menos 18 anos ou é representado por um responsável legal. Se você não concordar com estes
                termos, não deve utilizar a aplicação.
              </Typography>

              <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                3. Cadastro e conta
              </Typography>
              <Typography variant="body2" paragraph>
                Para usar o Sagrada Visão, você precisa criar uma conta, informando dados verdadeiros e atualizados. Você se
                compromete a não compartilhar sua senha e códigos de confirmação com outras pessoas, a manter seus dados de
                contato atualizados e a ser responsável por todas as ações feitas na sua conta.
              </Typography>

              <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                4. Uso do Sagrada Visão
              </Typography>
              <Typography variant="body2" paragraph>
                Pelo aplicativo, você pode visualizar médicos oftalmologistas parceiros e seus horários disponíveis,
                agendar consultas e acompanhar seus agendamentos. Os atendimentos médicos são prestados exclusivamente pelos
                médicos parceiros, que são os únicos responsáveis pelas orientações, diagnósticos e tratamentos realizados.
              </Typography>

              <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                5. Consultas, remarcações e faltas
              </Typography>
              <Typography variant="body2" paragraph>
                Cada médico ou clínica pode ter suas próprias regras de agendamento, remarcação, cancelamento e cobrança
                por faltas. Sempre que possível, avise com antecedência se não puder comparecer a uma consulta. O Sagrada
                Visão não é responsável por valores cobrados diretamente pelos médicos, clínicas ou convênios.
              </Typography>

              <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                6. Privacidade e proteção de dados
              </Typography>
              <Typography variant="body2" paragraph>
                O Sagrada Visão se preocupa com a proteção dos seus dados pessoais. Suas informações serão tratadas de
                acordo com a legislação aplicável e com a nossa Política de Privacidade, que detalha como coletamos, usamos
                e protegemos seus dados.
              </Typography>

              <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                7. Uso adequado do aplicativo
              </Typography>
              <Typography variant="body2" paragraph>
                Você se compromete a não usar o Sagrada Visão para fins ilegais, ofensivos ou discriminatórios, a não tentar
                invadir ou prejudicar o funcionamento do aplicativo e a não criar cadastros falsos ou usar dados de terceiros
                sem autorização.
              </Typography>

              <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                8. Responsabilidades
              </Typography>
              <Typography variant="body2" paragraph>
                O Sagrada Visão se responsabiliza por disponibilizar o aplicativo de forma razoavelmente segura e estável e
                adotar medidas de segurança para proteger seus dados. Os médicos parceiros são os únicos responsáveis pelos
                atendimentos, diagnósticos e tratamentos realizados.
              </Typography>

              <Typography variant="subtitle1" fontWeight={600} gutterBottom>
                9. Comunicações
              </Typography>
              <Typography variant="body2" paragraph>
                Podemos enviar avisos e lembretes relacionados às suas consultas e à sua conta por e-mail, SMS ou
                notificações no aplicativo. Ao usar o Sagrada Visão, você autoriza o envio dessas comunicações.
              </Typography>
            </Box>

            <Box mt={3}>
              <Typography variant="body2">
                Para ler a versão completa destes termos, acesse
                <Button
                  variant="text"
                  size="small"
                  sx={{
                    textTransform: "none",
                    fontWeight: 600,
                    ml: 0.5,
                    p: 0,
                    minWidth: "auto",
                  }}
                  onClick={() => {
                    setOpenTermsModal(false);
                    navigate(ROUTES.TERMS_OF_USE);
                  }}
                >
                  /termos-de-uso
                </Button>
                .
              </Typography>
            </Box>
          </DialogContent>
          <DialogActions>
            <Button onClick={() => setOpenTermsModal(false)} color="inherit">
              Fechar
            </Button>
          </DialogActions>
        </Dialog>
    </Box>
    )
}
